import { styled } from '@material-ui/styles'

const StyledForm = styled('form')(() => ({
  width: '100%',
  maxWidth: 800,
  margin: '0 auto',
}))

export default StyledForm
